{
  "title": "Запрошення",
  "invite": "Запросити",
  "dialog": {
    "title": "Запросити учасника",
    "description": "Надішліть email-запрошення приєднатися до цієї школи.",
    "role": "Роль",
    "email": "Ел. пошта",
    "emailPlaceholder": "name@example.com",
    "class": "Клас",
    "classPlaceholder": "Оберіть клас",
    "noClasses": "Ще немає активних класів — спершу створіть клас.",
    "pupil": "Учень (їхня дитина)",
    "pupilPlaceholder": "Оберіть учня",
    "noPupils": "Немає активних учнів — спершу запросіть учня.",
    "submit": "Надіслати запрошення",
    "submitting": "Надсилаємо…",
    "success": "Запрошення надіслано",
    "failed": "Не вдалося надіслати запрошення"
  },
  "myParent": {
    "title": "Запросіть батьків чи опікуна",
    "description": "Додайте когось із батьків або опікунів, щоб вони бачили ваші домашні завдання, оцінки й оголошення школи.",
    "emailLabel": "Їхня ел. пошта",
    "submit": "Надіслати запрошення",
    "emailRequired": "Спершу введіть їхню електронну адресу",
    "sent": "Готово. На {{email}} надійде посилання — попросіть перевірити пошту (і теку «Спам»).",
    "success": "Запрошення надіслано",
    "note": "Вони приєднаються як ваші батьки й бачитимуть тільки ваші роботи — нічиї більше."
  },
  "validation": {
    "emailRequired": "Вкажіть ел. пошту",
    "emailInvalid": "Введіть дійсну адресу ел. пошти",
    "classRequired": "Для запрошення учня потрібен клас",
    "pupilRequired": "Для запрошення батьків потрібно вказати дитину"
  },
  "list": {
    "filterLabel": "Статус",
    "all": "Усі",
    "empty": "Ще немає запрошень.",
    "emptyFiltered": "Немає запрошень із таким статусом.",
    "table": {
      "email": "Ел. пошта",
      "role": "Роль",
      "target": "Для",
      "invitedBy": "Запросив(-ла)",
      "status": "Статус",
      "expires": "Діє до"
    },
    "resend": "Надіслати ще раз",
    "resent": "Запрошення надіслано повторно",
    "revoke": "Відкликати",
    "revokeTitle": "Відкликати це запрошення?",
    "revokeDescription": "Посилання з листа перестане діяти. Пізніше цю людину можна запросити знову.",
    "revoked": "Запрошення відкликано"
  },
  "status": {
    "pending": "Очікує",
    "accepted": "Прийнято",
    "revoked": "Відкликано",
    "expired": "Прострочено"
  },
  "landing": {
    "title": "Вас запрошено",
    "invitedBy": "{{name}} запрошує вас приєднатися до «{{school}}».",
    "roleLabel": "Ваша роль",
    "classLabel": "Клас",
    "emailNote": "Це запрошення надіслано на {{email}}.",
    "emailMismatch": "Ви увійшли з іншою ел. поштою, ніж у запрошенні — прийняти його не вдасться. Увійдіть із запрошеною поштою або попросіть нове запрошення.",
    "accept": "Прийняти запрошення",
    "accepting": "Приймаємо…",
    "accepted": "Вітаємо у школі «{{school}}»!",
    "decline": "Не зараз",
    "invalidTitle": "Це запрошення недійсне",
    "invalidText": "Посилання недійсне, прострочене або вже використане. Попросіть школу надіслати нове.",
    "goHome": "На головну",
    "checking": "Перевіряємо запрошення…"
  }
}
